import React from "react"
import {
    Container,
    Col,
    Row,
    Button
  } from 'reactstrap';
  import Database from "./Database"
  import ReactSVG from 'react-svg'
  import worldmapa from "./images/worldmapa.svg"
  import worldmapb from "./images/worldmapb.svg"
  import worldmapc from "./images/worldmapc.svg"

import candidatea from "./images/candidatea.png"
import candidateb from "./images/candidateb.png"
import candidatec from "./images/candidatec.png"
import candidated from "./images/candidated.png"
import candidatee from "./images/candidatee.png"

import plurality from "./images/plurality.png"
import majority from "./images/majority.png"
import proportional from "./images/proportional.png"

  import Header from "./Header"


  class HowVotesCounted extends React.Component{
    constructor(){
        super()
        this.state={
            scenario1:false,
            scenario2:false,
            scenario3:false,
            scenario3a:false,
            scenario3b:false
        }
        //takes the handleClick method that I created and binds it to my class "HowVotesCounted"
        this.handleClick=this.handleClick.bind(this)
        this.handleOne=this.handleOne.bind(this)
        this.handleTwo=this.handleTwo.bind(this)
        this.handleThreeA=this.handleThreeA.bind(this)
        this.handleThreeB=this.handleThreeB.bind(this)
    }

    handleOne(){
        this.setState({
            scenario1:true,
            scenario2:false,
            scenario3a:false,
            scenario3b:false
        })
    }
    handleTwo(){
        this.setState({
            scenario1:false,
            scenario2:true,
            scenario3a:false,
            scenario3b:false
        })
    }
    handleThreeA(){
        this.setState({
            scenario1:false,
            scenario2:false,
            scenario3a:true,
            scenario3b:false
        })
    }
    handleThreeB(){
        this.setState({
            scenario1:false,
            scenario2:false,
            scenario3a:false,
            scenario3b:true
        })
    }

    handleClick(){
        // If you don't care about the previous state then just pass an object.
        // this.setState({
        //     count:1
        // })
        // If you do care however then pass an arrow function
        this.setState((prevState) => {
            return {
                count:prevState.count+1
            }
        }
        )
    }

    render(){

        const ValidCountries = Database.filter(function(data){
            return(
                data.VotingIn2019 !== "NA"
            )
        })

        function clearsvg(){
            let allsvg=["AF","AL","AO","AE","AR","AM","AU","AT","AZ","BI","BE","BJ","BF","BD","BG","BA","BY","BZ","BO","BR","BN","BT","BW","CF","CA","CH","CL","CN","CI","CM","CD","CG","CO","CR","CU","CZ","DE","DJ","DK","DO","DZ","EC","EG","ER","EE","ET","FI","FJ","GA","GB","GE","GH","GN","GM","GW","GQ","GR","GL","GT","GY","HN","HR","HT","HU","ID","IN","IE","IR","IQ","IS","IL","IT","JM","JO","JP","KZ","KE","KG","KH","KR","KW","LA","LB","LR","LY","LK","LS","LT","LU","LV","MA","MD","MG","MX","MK","ML","MM","ME","MN","MZ","MR","MW","MY","NA","NE","NG","NI","NL","NO","NP","NZ","OM","PK","PA","PE","PH","PG","PL","KP","PT","PY","PS","QA","RO","RU","RW","EH","SA","SD","SS","SN","SL","SV","RS","SR","SK","SI","SE","SZ","SY","TD","TG","TH","TJ","TM","TL","TN","TR","TW","TZ","UG","UA","UY","US","UZ","VE","VN","VU","YE","ZA","ZM","ZW","SO","GF","FR","ES","AW","AI","AD","AG","BS","BM","BB","KM","CV","KY","DM","FK","FO","GD","HK","KN","LC","LI","MV","MT","MS","MU","NC","NR","PN","PR","PF","SG","SB","ST","SX","SC","TC","TO","TT","VC","VG","VI","CY","RE","YT","MQ","GP","CW","IC"]
            let datum = allsvg.map(function(data){
                let beans=""
                if (document.getElementById(data) !== null){
                    let beans = document.getElementById(data).setAttribute("style","fill:#f2f2f2")
                }
                return(
                        beans
                )
            })
            return datum;
        }


        function pluralitysystem(){
            clearsvg()
            let datum = ValidCountries.filter(function(data){
                return(
                    (data.VotingType === "First-past-the-post")
                )
            }).map(function(data){
                let dname=data.ISO;
                let didi=dname+"a";
                let beans=""
                if (document.getElementById(didi) !== null){
                    let beans = document.getElementById(didi).setAttribute("style","fill:#fb9d04")
                }
                return(
                        beans
                )
            })
            return datum;
        }


        function majoritysystem(){
            clearsvg()
            let datum = ValidCountries.filter(function(data){
                return(
                    (data.VotingType === "Majority")
                )
            }).map(function(data){
                let dname=data.ISO;
                let didi=dname+"b";
                let beans=""
                if (document.getElementById(didi) !== null){
                    let beans = document.getElementById(didi).setAttribute("style","fill:#fb9d04")
                }
                return(
                        beans
                )
            })
            return datum;
        }


        function proportionalsystem(){
            clearsvg()
            let datum = ValidCountries.filter(function(data){
                return(
                    (data.VotingType === "Proportional")
                )
            }).map(function(data){
                let dname=data.ISO;
                let didi=dname+"c";
                let beans=""
                if (document.getElementById(didi) !== null){
                    let beans = document.getElementById(didi).setAttribute("style","fill:#fb9d04")
                }
                return(
                        beans
                )
            })
            return datum;
        }



        return(
            <div className="minheight">
            <Header/>

        <Container>
            <Row>
            <Col>
                <br/>
                <br/>
                <h2 id="votingtype" className="display-3 text-center">How are votes counted?</h2>
                <br/>

                <p>Counting votes is simple right? Well, not quite. In fact, it's been <a href="https://www.youtube.com/watch?v=AhVR7gFMKNg">mathematically proven</a> that no voting system is completely fair if you have more than two candidates to choose from.</p>
                <p>Take a look at the following election results. The first candidate received the most votes at 44% but also was not the prefered candidate for 56% of the population. The second candidate received 38% and the third candidate received 22%.</p>
                <p><strong>Who do you think should be declared the winner based on this information?</strong></p>
                <br/>
                <p className="smalltext">MAKE A SELECTION</p>
                
            </Col>
            </Row>
            <Row>
                <Col onClick={this.handleOne} xs="4" lg="2" className="chooseperson text-center">
                <a href="#yourchoice"><img className="text-center" alt="Candidatea" width="100%" height="auto" src={candidatea}/></a>
                </Col>
                <Col onClick={this.handleTwo} xs="4" lg="2" className="chooseperson text-center">
                <a href="#yourchoice"><img className="text-center" alt="Candidateb" width="100%" height="auto" src={candidateb}/></a>
                </Col>
                <Col onClick={this.handleTwo} xs="4" lg="2" className="chooseperson text-center">
                <a href="#yourchoice"><img className="text-center" alt="Candidatec" width="100%" height="auto" src={candidatec}/></a>
                </Col>
                <Col onClick={this.handleThreeA} xs="4" lg="2" className="chooseperson text-center">
                <a href="#yourchoice"><img className="text-center" alt="Candidated" width="100%" height="auto" src={candidated}/></a>
                </Col>
                <Col onClick={this.handleThreeB} xs="4" lg="2" className="chooseperson text-center">
                <a href="#yourchoice"><img className="text-center" alt="Candidatee" width="100%" height="auto" src={candidatee}/></a>
                </Col>
                
            </Row>

            <Row id="yourchoice" style={{marginTop:"15px"}}>
            <Col>

            <div style={{display: this.state.scenario1 ? 'block' : 'none'}}>
            <h3><strong>You prefer the plurality method.</strong></h3>

            <p><em>Also known as "first-past-the-post", “winner takes all” or “simple majority”.</em></p>
            <p>In this voting system, each voter is allowed to vote for one candidate. The winner is whoever receives the most votes regardless of whether or not this constitutes an absolute majority.</p>
            <img className="text-center" alt="Plurality" width="100%" height="auto" src={plurality}/>

            {/* <p>Countries that follow the plurality system:</p>
            <ReactSVG
            src={worldmapa}
            svgClassName="Countries following the plurality system"
            onInjected={(error, svg) => {
            if (error) {
                console.error(error)
                return
            }
            }}
            /> */}
            </div>

            <div style={{display: this.state.scenario2 ? 'block' : 'none'}}>
                <h3><strong>Oops, no voting system supports this candidate winning.</strong></h3>
            </div>
            
            <div style={{display: this.state.scenario3a ? 'block' : 'none'}}>
                <h3><strong>You prefer the majority method.</strong></h3>
                <p><em>Also known as the "second ballot", “instant run-off” or “alternative voting”.</em></p>
                <p>In this voting system, the winning candidate must win at least 50% of the vote. If not, then the vote is carried over into a second round where the top candidates go head to head.</p>
                <img className="text-center" alt="Majority" width="100%" height="auto" src={majority}/>

                {/* <p>Countries that follow the majority system:</p>
                <ReactSVG
                src={worldmapb}
                svgClassName="Countries following the majority system"
                onInjected={(error, svg) => {
                if (error) {
                console.error(error)
                return
                }
                }}
                /> */}
            </div>
                <div style={{display: this.state.scenario3b ? 'block' : 'none'}}>
                <h3><strong>You prefer the proportional method.</strong></h3>
                <p>In this voting system, votes are distributed proportionately between a list of candidates. In the example above 44% of the seats would go to the first candidate's party, 38% to the second and 22% to the third.</p>
                <img className="text-center" alt="Plurality" width="100%" height="auto" src={proportional}/>

                {/* <p>Countries that follow “proportionality”</p>
                <ReactSVG
                src={worldmapc}
                svgClassName="Countries following proportionality"
                onInjected={(error, svg) => {
                if (error) {
                console.error(error)
                return
                }
                }}
                /> */}
                </div>

            </Col>
            </Row>
        </Container>
        </div>
        )
    }
}

export default HowVotesCounted